
export const TopicValues = [
    { value: 1, text: 'Demonstrationen/Studentenunruhen' },
    { value: 2, text: 'Dutschke' },
    { value: 3, text: 'Evangelische Kirche und Studenten' },
    { value: 4, text: 'Hochschulreform' },
    { value: 5, text: 'Kommune I/Teufel/etc.' },
    { value: 6, text: 'Mahler' },
    { value: 7, text: 'Schah/Ohnesorg/Kurras' },
    { value: 8, text: 'SDS' },
    { value: 9, text: 'Sonstiges' },
    { value: 10, text: 'Springer' },
    { value: 11, text: 'Universitäten (diverse Vorgänge)' }
]

const MediaValues = [
    { value: 1, text: 'BERLINER MORGENPOST' },
    { value: 2, text: 'BILD (Berlin)' },
    { value: 3, text: 'BILD am SONNTAG' },
    { value: 4, text: 'DIE WELT (Berlin)' },
    { value: 5, text: 'WELT am SONNTAG' },
    { value: 6, text: 'B.Z.' },
    { value: 7, text: 'HAMBURGER ABENDBLATT' },
    { value: 8, text: 'Tagesspiegel', external: true },
    { value: 9, text: 'Telegraf', external: true }
]

const TextTypeValues = [
    { value: 1, text: 'Bericht' },
    { value: 2, text: 'Glosse' },
    { value: 3, text: 'Interview' },
    { value: 4, text: 'Karikatur' },
    { value: 5, text: 'Kommentar' },
    { value: 6, text: 'Leserbrief' },
    { value: 7, text: 'Reportage' },
    { value: 8, text: 'Sonstiges' }
]

const YesNoValues = [
    { value: 1, text: 'Ja' },
    { value: 2, text: 'Nein' },
    { value: 3, text: 'Ristock als Demoteilnehmer' },
    { value: 4, text: 'Porträt Schlamm' },
    { value: 5, text: 'Karikatur von Oskar' },
]

const PlacementValues = [
    { value: 1, text: 'Aufmacher' },
    { value: 2, text: 'Beisteller' },
    { value: 3, text: 'Fuß' },
    { value: 4, text: 'Ganzseite' },
    { value: 5, text: 'Zweitstück' }
]

const ExportFieldMapper = {
    'Dateinummer':  'id',
    'Thema':        'topic',
    'Objekt':       'object',
    'Datum':        'dateExport',
    'Ges-Umfang':   'pageCount',
    'Platzierung':  'place',
    'auf Seite(n)': 'page',
    'Überschrift':  'headline',
    'Dachzeile':    'kicker',
    'Unterzeile':   'subline',
    'Autoren':      'author',
    'Inhalt':       'content',
    'Abbildungen':  'illustration',
    'Textsorte':    'text'
}

const ExportFieldMeta = [
    [
        {
            'key': 'charset',
            'value': 'utf-8'
        }
    ]
]

class LookUpHelper {
    constructor(val) {
        this.values = val
        this.valueMap = {}
        this.textMap = {}

        for (let i = 0; i < this.values.length; i++) {
            this.valueMap[this.values[i].value] = i
            this.textMap[this.values[i].text]   = i
        }
    }

    getValues(filter) {
        if (typeof filter == 'function') {
            return this.values.filter(filter)
        }

        return this.values
    }

    getTextMapByValue(idx) {
        let idxSlice = idx
        let res = []

        if (!Array.isArray(idxSlice)) {
            idxSlice = [idxSlice]
        }

        for (let i = 0; i < idxSlice.length; i++) {
            let val = this.getByValue(idxSlice[i])
            if (val == false) {
                continue
            }

            res.push(val.text)
        }

        return res.join(', ')
    }

    getByValue(idx) {
        let i = this.valueMap.hasOwnProperty(idx)
        if (i === true) {
            return this.values[this.valueMap[idx]]
        }

        return false
    }

    getByText(idx) {
        let i = this.textMap.hasOwnProperty(idx)
        if (i === true) {
            return this.values[this.textMap[idx]]
        }

        return false
    }
}

class FieldMapper {
    constructor() {
        this.topic        = new LookUpHelper(TopicValues)
        this.media        = new LookUpHelper(MediaValues)
        this.type         = new LookUpHelper(TextTypeValues)
        this.placement    = new LookUpHelper(PlacementValues)
        this.illustration = new LookUpHelper(YesNoValues)
        this.export       = {
            fields: ExportFieldMapper,
            meta: ExportFieldMeta
        }
    }
}

export default new FieldMapper()


// WEBPACK FOOTER //
// ./src/mapping/index.js